import React from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Avatar } from "react-native-paper";

type UserAvatarProps = {
  size?: number;
  avatarUrl?: string | null;
  fullName?: string | null;
  name?: string | null;
  email?: string | null;
  style?: StyleProp<ViewStyle>;
};

const getInitials = ({
  fullName,
  name,
  email,
}: Pick<UserAvatarProps, "fullName" | "name" | "email">): string => {
  const baseName = (fullName || name || "").trim();
  if (baseName) {
    const parts = baseName.split(/\s+/).filter(Boolean);
    const initials = parts
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || "")
      .join("");
    if (initials) {
      return initials;
    }
  }

  if (email?.trim()) {
    return email.trim()[0].toUpperCase();
  }

  return "U";
};

export default function UserAvatar({
  size = 48,
  avatarUrl,
  fullName,
  name,
  email,
  style,
}: UserAvatarProps) {
  const normalizedUrl = avatarUrl?.trim();

  if (normalizedUrl) {
    return (
      <Avatar.Image size={size} source={{ uri: normalizedUrl }} style={style} />
    );
  }

  return (
    <Avatar.Text
      size={size}
      label={getInitials({ fullName, name, email })}
      style={style}
    />
  );
}
